module.exports = __webpack_public_path__ + "7_13_13_56_28/img/logo1.22025f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 1